import { useFormContext } from 'react-hook-form';

import type { CheckoutFormState } from './Checkout.types';

export const useCheckoutForm = () => useFormContext<CheckoutFormState>();
